module.exports = __webpack_public_path__ + "static/img/heroimage_login_large.972d00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_login_large.png
// module id = 175
// module chunks = 1